import { useEffect, useState } from 'react';
import _isEmpty from 'lodash/isEmpty';
import { decodeStorageLatin, encodeStorage, encodeStorageLatin } from 'functions/storageBase64';
import { CURRENT_GIFT_TABLE, TOTAL_GIFT_TABLES, TOTAL_GIFT_TABLES_CLOSED, TOTAL_GIFT_TABLES_OPEN } from 'constants/storage64';
import { useStore } from 'store';
import { setGiftTable } from 'store/actions/giftTable';


const useUpdateGifts = () => {

    const [, dispatch] = useStore((state) => state.giftTable.giftTable)

    const STORAGE_GIFT_TABLE = decodeStorageLatin(CURRENT_GIFT_TABLE)
    const STORAGE_GIFT_TOTAL = decodeStorageLatin(TOTAL_GIFT_TABLES)
    const STORAGE_GIFT_OPEN= decodeStorageLatin(TOTAL_GIFT_TABLES_OPEN)
    const STORAGE_GIFT_CLOSED = decodeStorageLatin(TOTAL_GIFT_TABLES_CLOSED)
    
    const [resultsEvent, setResultEvent] = useState(null)
    const setResponseEvents = (events) => {
        setResultEvent(events)
    }


    const [STORAGE_GT, setSTORAGE_GT] = useState(STORAGE_GIFT_TABLE)
    useEffect(()=>{
        if(!_isEmpty(resultsEvent)){
            const storageTable = {
                evento: STORAGE_GIFT_TABLE?.evento
            }
            const responseTable = resultsEvent
            const newStorageTable = {
                ...storageTable,
                ...responseTable
            }
            // console.log('useUpdateGifts: ',newStorageTable)
            encodeStorage('CURRENT_GIFT_TABLE', newStorageTable)
            encodeStorageLatin(CURRENT_GIFT_TABLE, newStorageTable)
            setSTORAGE_GT(newStorageTable)
            dispatch(setGiftTable(newStorageTable))
        }
    },[ resultsEvent ])

        
    return {
        STORAGE_GIFT_TABLE,
        STORAGE_GIFT_TOTAL,
        STORAGE_GIFT_OPEN,
        STORAGE_GIFT_CLOSED,
        STORAGE_GT,
        setResponseEvents
    }
}

export default useUpdateGifts